import React, { Component } from 'react';
import {getDocumentVersions} from '../store/actions/fileActions.js'
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {connect} from 'react-redux';
import env from '../ENV';
import FormatDateTimeInIST from '../Classes/FormatDateTimeInIST'


const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class FileVersionModal extends React.Component {
    constructor(props){
        super(props);
        this.state ={
            versionList:[],
            OpenVersionModal:this.props.OpenVersionModal,
            uploadedId: this.props.uploadedId? this.props.uploadedId:"",

        }
        this.OpenVersionModal = this.OpenVersionModal.bind(this);
        this.getVersions = this.getVersions.bind(this);
        this.dateformate = this.dateformate.bind(this);
    }

    componentWillMount(){
        this.getVersions();
    }

    dateformate(dateVal){
        let d = new Date(dateVal);
        return d.toDateString();
    }

    async getVersions(){
        if(this.state.uploadedId){
            await this.props.getDocumentVersions(this.state.uploadedId);
            let versionList = this.props.versions && this.props.versions.results ? this.props.versions.results:[];
            this.setState({versionList});   
        }
    }

    OpenVersionModal(status){
        if(status==false){
            this.setState({versionList:[],uploadedId:"",OpenVersionModal:false});
            this.props.OpenVersionModal(null);
        }
    }

    render(){
        return(
            <Modal isOpen={this.state.OpenVersionModal} >
                <div className={"modal-bg" + (this.props.modal === 'false'  ? 'open' : '')}>
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header">
                            <div className="modal-text"><h4 >Document Version History</h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={(e)=>this.OpenVersionModal(false)} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>
                    <div>
                        <ModalBody Style="modal-body modalbodys">

                                <div className="row ">
                                    <div className="col-8"></div>
                                    <div className="col-4 pb-2">
                                        {/* <DropdownFlat defaultopt="-Select-"  data={this.state.Date} actions={this.handleSelect} keyObjName={"value"} valueObjName={"label"} /> */}
                                    </div>
                                </div> 
                                
                                {this.state.versionList && this.state.versionList.length<1 && <div className="row col-sm-12" style={{textAlign:"center",display:"block",top:"40%"}}>
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>}
                                

                                <div>
                                </div>    
                                {
                                    this.state.versionList && this.state.versionList.map((item,i)=>{
                                       
                                        return <div key={i} className="">
                                            <div className="row border border-radius-modal ml-2 mr-2 mt-2">
                                                <div className="col-10">
                                                    <div><h5>{item.DocumentName}</h5></div>
                                                    {/* <div className="text-left">comments(<em>if any</em>): None</div> */}
                                                    <div className=" row text-left">
                                                        <div className="col-12 ">Version: #{item.VersionId}</div>
                                                        <div className="col-12">Uploaded On: {FormatDateTimeInIST(item.CreatedOn)}</div>
                                                        <div className="col-12">Uploaded By: {item.FullName}</div>
                                                        <div className="col-12">
                                                        {i==0&&<span className="badge badge-success">Current Version </span>}
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="row pt-4" style={{float:"right",paddingRight:"10px"}}>
                                                    <div className="ml-4 border" > 
                                                        <a href={FILESERVER_ROOT_URL + "files/Documents/"+item.VersionId+"/download-version"} target="_blank" download> 
                                                            <FontAwesomeIcon icon={"eye"}  color={"black"} title="View" size="lg" />
                                                        </a>
                                                    </div> 
                                                    {/* <div className="ml-4 border"> <FontAwesomeIcon icon={i==0?'check-circle':'history'} color={i==0?'green':'red'} size="lg" /></div>  */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }) 
                                }   
                        </ModalBody>
                    </div>
                    <div className="">    
                        <ModalFooter FooterStyle="modal-footer">
                            <div>
                                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={()=>this.OpenVersionModal(false)} type="submit">Close</button> 
                            </div>
                        </ModalFooter>
                    </div>
            </div>
          </Modal>
   
        )
    }
}

const mapStateToProps  = (state) => ({ 
    versions:state.file.file_versions
})
export default connect(mapStateToProps, {getDocumentVersions})(FileVersionModal)